import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { AccountModel } from '../../../../../../domain/models/account.model';
import { AccountContentService } from '../../../../../../domain/services/account-content/account-content.service';
import { DialogService } from '../../../../../../domain/services/dialog/dialog.service';

/** Account-scoped ATTACHMENTS tab. */
@Component({
  selector: 'app-account-attachments-tab',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatTableModule],
  templateUrl: './account-attachments-tab.component.html',
  styleUrl: './account-attachments-tab.component.css'
})
export class AccountAttachmentsTabComponent implements OnInit {
  @Input() account!: AccountModel;

  attachments: any[] = [];
  displayedColumns = ['fileName', 'fileSize', 'uploadedAt', 'uploadedBy', 'actions'];
  loadError: string | null = null;

  constructor(private contentService: AccountContentService, private dialogService: DialogService) {}

  ngOnInit(): void {
    this.loadAttachments();
  }

  loadAttachments(): void {
    if (!this.account?.id) { return; }
    this.contentService.getAttachments(this.account.id).subscribe({
      next: (rows) => { this.attachments = rows; },
      error: (err) => { console.error('Error loading attachments:', err); this.loadError = 'Unable to load attachments.'; }
    });
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.uploadFile(input.files[0]);
      input.value = '';
    }
  }

  uploadFile(file: File): void {
    if (!this.account?.id) { return; }
    this.contentService.uploadAttachment(this.account.id, file).subscribe({
      next: () => this.loadAttachments(),
      error: (err) => console.error('Error uploading file:', err)
    });
  }

  downloadAttachment(attachment: any): void {
    if (!this.account?.id) { return; }
    this.contentService.downloadAttachment(this.account.id, attachment.id).subscribe({
      next: (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = attachment.fileName;
        link.click();
        window.URL.revokeObjectURL(url);
      },
      error: (err) => console.error('Error downloading file:', err)
    });
  }

  deleteAttachment(attachmentId: number): void {
    if (!this.account?.id) { return; }
    this.dialogService.openDeletedDialog(
      'Delete Attachment',
      'Are you sure you want to delete this attachment? This action cannot be undone.',
      (confirmed: boolean) => {
        if (confirmed) {
          this.contentService.deleteAttachment(this.account.id!, attachmentId).subscribe({
            next: () => this.loadAttachments(),
            error: (err) => console.error('Error deleting attachment:', err)
          });
        }
      }
    );
  }

  formatFileSize(bytes: number): string {
    if (!bytes) { return '0 Bytes'; }
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
  }
}
